import moment from "moment";
import ApiService from "../../services/api";
import { mapGetters } from "vuex";

export default {
	props: {
		filtersToShow: Array
	},
	data: function() {
		return {
			//filters
			vehicleIdFilterField: "number_plate",
			showTimeFilter: false,
			//showTimeRangeFilter: true,
			timesFilter: [
				{
					id: 0,
					value: "ultimi 7gg"
				},
				{
					id: 1,
					value: "ultimi 15gg"
				},
				{
					id: 2,
					value: "Range di date"
				}
			],
			timefilterSelected: 0,
			startDate: null,
			endDate: null,

			showVehicleFilter: false,
			vehicles: [],
			vehiclesSelected: [],

			showDriverFilter: false,
			drivers: [],
			driversSelected: "",

			showGroupFilter: false,
			groupsData: [],
			groupsSelected: "",

			showDivisionFilter: false,
			hasDivisions: false,
			userDivisionEnabled: true,
			userDivisions: [],
			userDivisionsSelected: "",

			showDiagnioisTypeFilter: false,
			getTypeInformation: false,
			getTypeAnomaly: true,

			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #",

			itemVehicleTemplate: "<div style='height: 30px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			tagVehicleTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",

			driverOptionLabel: {
				id: "",
				name: "",
				surname: "",
				name_surname_fiscalcode: "Seleziona un conducente",
				fiscal_code: ""
			},
			itemDriverTemplate: "<div style='height: 30px'>#= surname # #= name #<br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			tagDriverTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= surname # #= name #<br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			itemGroupTemplate: "<span style='height: 16px'>#= description #</span>",
			itemUserDivisionTemplate: "<span style='height: 16px'>#= value #</span>"
		};
	},
	watch: {
		timefilterSelected: function(newValue) {
			console.log("cambio date");
			switch (newValue) {
				case "0":
					this.startDate = moment()
						.add(-7, "days")
						.startOf("day"); //max from api
					this.endDate = moment().endOf("day");
					break;
				case "1":
					this.startDate = moment()
						.add(-15, "days")
						.startOf("day"); //max from api
					this.endDate = moment().endOf("day");
					break;
				default:
					this.startDate = moment()
						.add(-1, "months")
						.startOf("day"); //max from api
					this.endDate = moment().endOf("day");
					break;
			}
			this.timeRangeChange();
		},
		vehiclesSelected: function(newValue) {
			this.$emit("on-filter-plate-change", this.vehiclesSelected);
		},
		driversSelected: function(newValue) {
			this.$emit("on-filter-driver-change", this.driversSelected);
		},
		userDivisionsSelected: function(newValue) {
			this.$emit("on-filter-division-change", this.userDivisionsSelected);
		},
		groupsSelected: function(newValue) {
			this.$emit("on-filter-group-change", this.groupsSelected);
		},
		getTypeInformation: function(newValue) {
			if (this.getTypeAnomaly == false && this.getTypeInformation == false) {
				this.getTypeAnomaly = true;			
			}

			this.$emit("on-diagnosis-type-change", {
				information: this.getTypeInformation,
				anomaly: this.getTypeAnomaly
			});
		},
		getTypeAnomaly: function(newValue) {
			var self = this;
			if (newValue == false && this.getTypeInformation == false) {
				self.$nextTick(function() {
					self.getTypeAnomaly = true;	

					this.$emit("on-diagnosis-type-change", {
						information: this.getTypeInformation,
						anomaly: this.getTypeAnomaly
					});
				});

				return;
			}

			this.$emit("on-diagnosis-type-change", {
				information: this.getTypeInformation,
				anomaly: this.getTypeAnomaly
			});
		}
	},
	created() {
		var self = this;
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;

		if (this.settings && this.settings.hasDivisions) this.hasDivisions = true;

		if (this.filtersToShow && this.filtersToShow.length > 0) {
			this.filtersToShow.forEach(element => {
				switch (element.id) {
					case "timerange":
						self.showTimeFilter = true;
						self.timefilterSelected = element.value.period;
						self.startDate = element.value.startRange;
						self.endDate = element.value.endRange;
						break;
					case "divisions":
						self.showDivisionFilter = true;
						break;
					case "groups":
						self.showGroupFilter = true;
						break;
					case "vehicles":
						self.showVehicleFilter = true;
						break;
					case "drivers":
						self.showDriverFilter = true;
						break;
					case "diagnosis-type":
						self.showDiagnioisTypeFilter = true;
						self.getTypeInformation = element.value.information;
						self.getTypeAnomaly = element.value.anomaly;
						break;
					default:
						break;
				}
			});
		} else {
			this.startDate = moment().add(-7, "days"); //max from api
			this.endDate = moment().endOf("day");
		}

		this.getAllVehicles();
		this.getAllDrivers();
		if (this.hasDivisions) this.getUserDivision();
		this.getGroups();
	},

	methods: {
		applyReportFilter() {
			this.$emit("on-filter-apply-click");
		},
		resetReportFilter() {
			var self = this;
			this.filtersToShow.forEach(element => {
				switch (element.id) {
					case "timerange":
						//self.showTimeFilter = true;
						self.timefilterSelected = "0";
						//self.startDate = element.value.startRange;
						//self.endDate = element.value.endRange;
						break;
					case "divisions":
						self.userDivisionsSelected = [];
						break;
					case "groups":
						self.groupsSelected = [];
						break;
					case "vehicles":
						self.vehiclesSelected = [];
						break;
					case "drivers":
						self.driversSelected = [];
						break;
					case "diagnosis-type":
						//self.showDiagnioisTypeFilter = true;
						self.getTypeInformation = false;
						self.getTypeAnomaly = true;
						break;
					default:
						break;
				}
			});
			this.$emit("on-filter-clean-click");
		},
		onFilterTypeChange(type) {
			// if (type == "a") {
			// 	this.getTypeAnomaly = !this.getTypeAnomaly;
			// }
			// if (type == "i") {
			// 	this.getTypeInformation = !this.getTypeInformation;
			// }
			// this.setAllTypesIfNoSelected();
			this.$emit("on-diagnosis-type-change", {
				information: this.getTypeInformation,
				anomaly: this.getTypeAnomaly
			});
		},
		setAllTypesIfNoSelected() {
			if (this.getTypeAnomaly == false && this.getTypeInformation == false) {
				this.getTypeAnomaly = true;
				this.getTypeInformation = true;
			}
		},
		startDateChange(item) {
			var newStartDate = moment(item.sender.value());
			if (newStartDate > moment(this.endDate)) {
				this.endDate = moment(item.sender.value()).endOf("day");
			}
			this.startDate = newStartDate.startOf("day");
			this.timeRangeChange();
		},

		endDateChange(item) {
			var newEndDate = moment(item.sender.value());
			if (newEndDate < moment(this.startDate)) {
				this.startDate = moment(item.sender.value()).startOf("day");
			}
			this.endDate = newEndDate.endOf("day");

			this.timeRangeChange();
		},
		timeRangeChange() {
			this.$emit("on-filter-timerange-change", { startDate: this.startDate, endDate: this.endDate });
		},

		getGroups: function() {
			var self = this;
			ApiService.getGroupsData().then(res => {
				self.groupsData = res.map(function(item) {
					return {
						id: item.id,
						description: item.name
					};
				});

				self.groupsData = self._.sortBy(self.groupsData, item => {
					return item.description ? item.description.toLowerCase() : "";
				});

				self.groupsData.unshift({
					id: -1,
					description: ""
				});
			});
		},
		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate ? vehicle.number_plate : "",
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
					};
				});

				self.vehicles = self._.sortBy(self.vehicles, item => {
					return item.number_plate;
				});
			});
		},
		getAllDrivers() {
			var self = this;
			ApiService.getDriversData({ page: 0, pageSize: 100000 }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: driver.id,
						name: driver.name,
						surname: driver.surname,
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname", "name"]);

				self.drivers.unshift({
					id: 0,
					name: "NON DISPONIBILE",
					surname: "",
					fiscal_code: ""
				});

				self.drivers.unshift({
					id: -1,
					name: "",
					surname: "",
					fiscal_code: ""
				});
			});
		},
		getUserDivision() {
			var self = this;
			ApiService.getUserDivision().then(res => {
				self.userDivisions = res.map(function(item) {
					return {
						id: item.key,
						value: item.value
					};
				});

				self.userDivisions = self._.sortBy(self.userDivisions, item => {
					return item.value.toLowerCase();
				});

				if (self.userDivisions.length == 1) {
					self.$nextTick(() => {
						self.userDivisionsSelected = self.userDivisions[0].id.toString();
						self.userDivisionEnabled = false;
					});
				}

				self.userDivisions.unshift({
					id: -1,
					value: ""
				});
			});
		}
	},
	computed: {
		...mapGetters(["settings"]),
		startDateString() {
			return moment(this.startDate).format("DD MMMM YYYY");
		},
		endDateString() {
			return moment(this.endDate).format("DD MMMM YYYY");
		}
	}
};
